import React from 'react';
import { Field } from 'react-final-form';
import cx from 'classnames';
import PropTypes from 'prop-types';

import RadioGroup from '../../../../../../../components/RadioGroup';
import FloodIcon from '../../../../../../../icons/Flood';
import conditionalValidation from '../../../../../../../validators/conditionalValidation';
import fieldRequiredStandard from '../../../../../../../validators/fieldRequired';
import SectionTitle from '../../../../../common/SectionTitle';
import { useStandaloneWizardState } from '../../../../../standalone-wizard/StandaloneWizardProvider';

import styles from './FloodDisclosureCA.module.scss';

const FloodDisclosureCA = ({ className }) => {
  const { standAloneWizard } = useStandaloneWizardState();
  const fieldRequired = conditionalValidation(
    fieldRequiredStandard,
    !standAloneWizard,
  );

  return (
    <div className={cx(styles.container, className)}>
      <SectionTitle title="Flood Disclosure" icon={FloodIcon} />
      <label className={styles.label}>
        Do you know if this property is located in a flood zone?
      </label>
      <p className={styles.description}>
        California law requires you to disclose this. This generally means a
        geographic area that FEMA has defined according to varying levels of
        flood risk from the overflow of lakes, ponds, streams, rivers, creeks
        and any other inland waters.
      </p>
      <Field
        component={RadioGroup}
        id="custom_state_data.has_property_flooded"
        name="custom_state_data.has_property_flooded"
        radiosContainerClassName={styles.radioButtonsContainer}
        options={[
          {
            id: 'has_property_flooded_yes',
            value: true,
            label: 'Yes',
          },
          {
            id: 'has_property_flooded_no',
            value: false,
            label: 'No',
          },
        ]}
        validate={fieldRequired}
      />
    </div>
  );
};

FloodDisclosureCA.propTypes = {
  className: PropTypes.string,
};

export default FloodDisclosureCA;
